import { useNavigate } from "react-router-dom";
import { OrderEditorDrawer } from "../components/orders/OrderEditorDrawer";
import { useTabStore } from "../lib/tabStore";

/**
 * YENİ SİPARİŞ — uygulama içi SEKME olarak (eskiden çekmeceydi).
 *
 * Neden sekme: sipariş formu bu uygulamadaki en uzun formlardan biri — çok satırlı ürün
 * listesi, her satırda fiyat anlaşması ve canlı ATP/ham madde ihtiyacı tablosu. Çekmecede
 * kullanıcı bir ürünün stoğuna ya da reçetesine bakmak için sayfadan çıktığında çekmece de
 * kapanıyor ve doldurulan satırlar SİLİNİYORDU. Sekme mount kalır: başka sekmeye bakıp
 * geri dönüldüğünde form aynen durur (TabViews keep-alive).
 *
 * Kaydedince: sekme KENDİNİ KAPATIR ve sipariş listesine dönülür. Liste zaten mutasyonun
 * `invalidateQueries` çağrısıyla tazelenmiştir.
 *
 * DÜZENLEME bilinçli olarak ÇEKMECE kaldı (Siparişler listesindeki kalem düzenleme):
 * orada amaç mevcut bir kayda hızlı müdahale, listeden kopmadan.
 */
export const ORDER_NEW_PATH = "/orders/yeni";

export function OrderNewPage() {
  const navigate = useNavigate();
  const closeTab = useTabStore((s) => s.close);

  /** Sekmeyi kapat + listeye dön. Sekme bulunamasa bile (derin bağlantı) gezinme yapılır. */
  const back = () => {
    closeTab(ORDER_NEW_PATH);
    navigate("/orders");
  };

  return <OrderEditorDrawer open variant="page" orderId={null} onClose={back} />;
}
